import { BACKEND_URL } from "../url/Url";

const BASE = BACKEND_URL + "/gestion-salle-reunion/salles/";
const getAuthHeaders = () => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
};
const SalleService = {
  all: async () => {
    try {
      const response = await fetch(BASE, {
        headers : getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      return { success: false, error: error.message };
    }
  }
};

export default SalleService;
